import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import OnboardHeading from "../../../components/OnboardHeading";
import HeaderForm from "../../../components/HeaderForm";
import { getRevertUser } from "../../../api";
import revertIcon from "../../../assets/images/fa_refresh.svg";
import { useLocation } from "react-router-dom";
import PdfViewer from "../../../components/CustomPdf/pdf";

const TaskCustomPdf = () => {
  const { state } = useLocation();
  const pdfFullData = state?.document;
  const pdfData = state?.document?.custom_documents;
  const companyName = localStorage.getItem("company_name");
  const revertUserUrl = getRevertUser();
  const showRevert = Boolean(revertUserUrl);

  const handleRevertUser = () => {
    window.open(revertUserUrl, "_self");
  };

  const colProps = showRevert ? { md: 10, sm: 8 } : { md: 12, sm: 12 };

  return (
    <>
      <HeaderForm />
      <div className="profile_container">
        <Row>
          <Col {...colProps}>
            <OnboardHeading
              title="Complete Client Document"
              subtitle={companyName}
            />
          </Col>
          {showRevert ? (
            <Col
              md={2}
              sm={showRevert ? 4 : 2}
              className="d-flex align-items-center justify-content-end mb-4 mb-md-0"
            >
              <div className="revert">
                <Button
                  variant="danger"
                  className="revert_btn"
                  onClick={handleRevertUser}
                >
                  <img
                    src={revertIcon}
                    alt="revert"
                    className="revert-img me-1"
                  />
                  Revert User
                </Button>
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <div className="create-board">
          <div className="board-container">
            <div className="pdf-settings">
              <PdfViewer
                file={pdfData?.document_url}
                pdfData={pdfData}
                pdfFullData={pdfFullData}
                pageType="profile_task"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskCustomPdf;
